<template>
    <div class="modal is-active">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t("close-room.title") }}</p>
                <button class="delete" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <div v-if="!closing">
                    <p>{{ $t("close-room.confirm-text") }}</p>
                    <p v-if="haveError">{{ error }}</p>
                </div>
                <div v-if="closing">
                    <Loading />
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="closeRoom">
                    {{ $t("close-room.yes") }}
                </button>
                <button class="button" @click="closeModal">
                    {{ $t("close-room.no") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import Loading from "@/components/Loading";

export default {
    name: "close-room-modal",
    components: {
        Loading,
    },
    props: {
        roomId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            closing: false,
            error: "",
        };
    },
    computed: {
        haveError() {
            return this.error !== "";
        },
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        async closeRoom() {
            this.closing = true;
            try {
                await RepositoryFactory.conference.closeRoom({
                    roomId: this.roomId,
                });
                this.error = "";
                this.$emit("closed");
            } catch (error) {
                this.closing = false;
                this.error = "Error closing the room";
            }
        },
    },
};
</script>